
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/firemni-kurzy",
      function () {
        return require("private-next-pages/firemni-kurzy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/firemni-kurzy"])
      });
    }
  